import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, locationMapPM, mobileMap, mobileMapPM } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => {
        let locationLink = ''
        let mapImageMobile = null
        let mapImage = null
        if (locationId === 'Ab8324iqgy4BQgWK2Ufi') {
          locationLink = 'https://maps.app.goo.gl/WiM5e8HPvsL9VD3a6'
          mapImage = locationMap
          mapImageMobile = mobileMap
        } else {
          locationLink = 'https://maps.app.goo.gl/WiM5e8HPvsL9VD3a6'
          mapImage = locationMapPM
          mapImageMobile = mobileMapPM
        }
        return (
          <CFView>
            <MobileScreen>
              <CFLink href={locationLink} target="_blank">
                <CFImage
                  src={mapImageMobile}
                  w="100%"
                  alt="Samurai Sushi Map"
                />
              </CFLink>
            </MobileScreen>
            <DefaultScreen>
              <CFLink href={locationLink} target="_blank">
                <CFImage src={mapImage} w="100%" alt="Samurai Sushi Map" />
              </CFLink>
            </DefaultScreen>
          </CFView>
        )
      }}
    </CFSelect>
  )
}
